// extracted by mini-css-extract-plugin
module.exports = {"button":"AddOrgDialog_button__1AoKx","title":"AddOrgDialog_title__3A5Fa"};